import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, GiftIcon, CheckCircle2Icon, DownloadIcon, CreditCardIcon, ChevronDownIcon, ShoppingCartIcon, BookOpenIcon, CalculatorIcon, StarIcon, AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { UpsellPopup } from './UpsellPopup';
export function PriceBlock() {
  const [showDetails, setShowDetails] = useState(false);
  const [orderBump1Checked, setOrderBump1Checked] = useState(false);
  const [orderBump2Checked, setOrderBump2Checked] = useState(false);
  const [showUpsellPopup, setShowUpsellPopup] = useState(false);
  const basePrice = 12499;
  const bump1Price = 6000;
  const bump2Price = 6000;
  const total = basePrice + (orderBump1Checked ? bump1Price : 0) + (orderBump2Checked ? bump2Price : 0);
  const formatPrice = (n: number) => `${n.toLocaleString('es-AR')}`;
  const getCheckoutUrl = (bump1: boolean, bump2: boolean) => {
    if (bump1 && bump2) return 'https://amigospeludosarg.shop/cart/49011062767858:1';
    if (bump1) return 'https://amigospeludosarg.shop/cart/49010966954226:1';
    if (bump2) return 'https://amigospeludosarg.shop/cart/49011080462578:1';
    return 'https://amigospeludosarg.shop/cart/48933114577138:1';
  };
  const handleCheckoutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!orderBump1Checked && !orderBump2Checked) {
      setShowUpsellPopup(true);
    } else {
      trackAddToCart();
      window.open(getCheckoutUrl(orderBump1Checked, orderBump2Checked), '_blank', 'noopener,noreferrer');
    }
  };
  return <section id="precio" className="w-full bg-[#2D8C5A] py-8 md:py-24 px-4 md:px-6" data-id="element-157">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-center" data-id="element-158">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6" data-id="element-159">
          Recuperá la paz de tu hogar hoy mismo
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-5 md:mb-8 leading-relaxed" data-id="element-160">
          Por menos de lo que cuesta un kilo de piedras premium, llevate el
          sistema completo que salvará tu sofá y tu relación con tu gato.
        </p>

        <div className="bg-white rounded-2xl p-5 md:p-10 mb-8" data-id="element-161">
          <div className="mb-6" data-id="element-162">
            <motion.div key={total} initial={{
            scale: 1.1
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.3
          }} className="text-5xl md:text-6xl font-['Playfair_Display'] font-bold text-[#1C1C1C] mb-2" data-id="element-163">
              ${formatPrice(total)}
            </motion.div>
            <div className="text-lg text-[#1C1C1C]/70" data-id="element-164">
              Pago único - Descarga inmediata
            </div>
          </div>

          <div className="text-left bg-[#FAFAF7] rounded-lg p-3.5 md:p-6 mb-5 border border-[#1C1C1C]/5" data-id="element-165">
            <p className="text-xs font-semibold text-[#1C1C1C]/60 uppercase tracking-wide mb-2.5" data-id="element-166">
              Tu pack incluye:
            </p>
            <div className="space-y-2" data-id="element-167">
              <div className="flex items-center gap-2" data-id="element-168">
                <CheckCircle2Icon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-169" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-170">
                  <strong data-id="element-171">eBook:</strong> Protocolo de 72 Horas
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-172">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-173" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-174">
                  <strong data-id="element-175">Bono 1:</strong> Auditoría + Mapa N+1
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-176">
                    GRATIS
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-177">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-178" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-179">
                  <strong data-id="element-180">Bono 2:</strong> Kit "Sin Culpa" + Scripts
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-181">
                    GRATIS
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-182">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-183" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-184">
                  <strong data-id="element-185">Bono 3:</strong> Checklist "Bandeja Perfecta"
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-186">
                    GRATIS
                  </span>
                </span>
              </div>
              <AnimatePresence data-id="element-187">
                {orderBump1Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-188">
                    <div className="flex items-center gap-2 pt-1" data-id="element-189">
                      <CheckCircle2Icon className="w-4 h-4 text-[#D97706] flex-shrink-0" data-id="element-190" />
                      <span className="text-[#1C1C1C] text-sm" data-id="element-191">
                        <strong data-id="element-192">Extra:</strong> Scanner de Limpieza
                        <span className="ml-1.5 inline-block bg-[#D97706]/10 text-[#D97706] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-193">
                          +$6.000
                        </span>
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
              <AnimatePresence data-id="element-194">
                {orderBump2Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-195">
                    <div className="flex items-center gap-2 pt-1" data-id="element-196">
                      <CheckCircle2Icon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-197" />
                      <span className="text-[#1C1C1C] text-sm" data-id="element-198">
                        <strong data-id="element-199">Extra:</strong> Calendario 72 Horas
                        <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-200">
                          +$6.000
                        </span>
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <AnimatePresence data-id="element-201">
              {showDetails && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-202">
                  <div className="mt-4 pt-4 border-t border-[#1C1C1C]/10 space-y-5" data-id="element-203">
                    <div data-id="element-204">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-205">
                        BONO #1
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-206">
                        Auditoría Express "Puntos Calientes" (10 Min) + Mapa de
                        Bandejas N+1
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-207">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-208">
                          $14.000 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-209">
                        Auditoría guiada de 10 minutos para detectar los
                        disparadores reales del marcaje en tu hogar. Checklist
                        de barrido, scorecard de riesgo (0 a 20 puntos) y mapas
                        de ubicación N+1 listos para 1, 2 o 3 gatos.
                      </p>
                      <div className="space-y-1.5" data-id="element-210">
                        {['Checklist "Barrido del Hogar en 10 Min"', 'Scorecard de riesgo de ubicación', 'Mapas N+1 para 1, 2 y 3 gatos', 'Plantilla "Mis 2 ubicaciones candidatas"', 'Tracker de 7 días del patrón de marcaje'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-211">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-212" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-213">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-214">
                        ✓ En 10 min sabés qué cambiar. En 48 hs ya lo cambiaste.
                      </p>
                    </div>

                    <div data-id="element-215">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-216">
                        BONO #2
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-217">
                        Kit de Comunicación "Sin Culpa" (Scripts + Carteles +
                        Plan de 3 Días)
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-218">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-219">
                          $12.700 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-220">
                        Las palabras exactas para que tu pareja, hijos, visitas
                        y roommate entiendan las reglas sin discusiones ni
                        dramas.
                      </p>
                      <div className="space-y-1.5" data-id="element-221">
                        {['12 scripts listos para pareja, hijos, visitas y roommates', 'Protocolo Silencioso 90s para accidentes', '6 carteles imprimibles para zonas clave', 'Plan de 3 días (rutina mañana/tarde/noche)', 'Auto-guión anti-culpa para resetear tu cabeza'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-222">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-223" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-224">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-225">
                        ✓ Casa alineada desde el Día 1. Sin sabotajes.
                      </p>
                    </div>

                    <div data-id="element-226">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-227">
                        BONO #3
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-228">
                        Checklist "Bandeja Perfecta" (2 Min al Día)
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-229">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-230">
                          $9.500 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-231">
                        2 minutos al día. Una checklist AM/PM para mantener la
                        bandeja en el estándar exacto que hace que tu gato la
                        elija por instinto, todos los días.
                      </p>
                      <div className="space-y-1.5" data-id="element-232">
                        {['Checklist AM/PM imprimible (1 página A4)', 'Rutina de reset semanal anti-recaídas', 'Tracker de 14 días con AM/PM + eventos', 'Mini guía "3 ajustes express"', 'Versión móvil optimizada'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-233">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-234" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-235">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-236">
                        ✓ En 14 días el hábito de caja se consolida.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <button onClick={() => setShowDetails(!showDetails)} className="mt-3 flex items-center gap-1.5 text-[#2D8C5A] text-xs font-semibold hover:text-[#1f6b42] transition-colors cursor-pointer" data-id="element-237">
              <span data-id="element-238">
                {showDetails ? 'Ver menos' : 'Leer más sobre los bonos'}
              </span>
              <motion.div animate={{
              rotate: showDetails ? 180 : 0
            }} transition={{
              duration: 0.25
            }} data-id="element-239">
                <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-240" />
              </motion.div>
            </button>

            <div className="mt-2.5 pt-2.5 border-t border-[#1C1C1C]/10 flex justify-between items-center" data-id="element-241">
              <span className="text-xs text-[#1C1C1C]/60" data-id="element-242">
                Valor: <span className="line-through" data-id="element-243">$48.699</span>
              </span>
              <motion.span key={total} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.3
            }} className="text-base font-bold text-[#2D8C5A]" data-id="element-244">
                Hoy: ${formatPrice(total)}
              </motion.span>
            </div>
          </div>

          <motion.button onClick={handleCheckoutClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#2A5C42] text-white font-bold px-8 py-5 rounded-lg text-lg md:text-xl hover:bg-[#1f4531] transition-colors mb-4 text-center cursor-pointer shadow-lg" data-id="element-245">
            {'\xA1QUIERO RECUPERAR MI CASA AHORA!'}
          </motion.button>

          {/* ORDER BUMP #1 - Limpieza Técnica */}
          <div className={`mb-3 rounded-xl border-2 transition-all overflow-hidden ${orderBump1Checked ? 'border-[#D97706] bg-[#FEF3C7]' : 'border-dashed border-[#D97706]/60 bg-white'}`} data-id="element-246">
            <div className="bg-[#D97706] text-white text-[10px] font-bold uppercase tracking-wider text-center py-1.5 px-4 flex items-center justify-center gap-1.5" data-id="element-247">
              <StarIcon className="w-3 h-3 fill-white" data-id="element-248" />
              Altamente recomendado
            </div>
            <div onClick={() => setOrderBump1Checked(!orderBump1Checked)} className="flex items-center gap-3 p-3.5 md:p-4 cursor-pointer" data-id="element-249">
              <motion.div animate={{
              scale: orderBump1Checked ? 1 : 1,
              backgroundColor: orderBump1Checked ? '#B45309' : '#ffffff'
            }} className={`w-5 h-5 rounded flex-shrink-0 flex items-center justify-center border-2 transition-colors ${orderBump1Checked ? 'border-[#B45309]' : 'border-[#D97706]'}`} data-id="element-250">
                {orderBump1Checked && <CheckCircle2Icon className="w-3.5 h-3.5 text-white" data-id="element-251" />}
              </motion.div>
              <div className="flex-1 min-w-0" data-id="element-252">
                <p className="text-sm font-semibold text-[#1C1C1C] leading-snug" data-id="element-253">
                  Scanner de Limpieza Técnica
                </p>
                <p className="text-xs text-[#1C1C1C]/60" data-id="element-254">
                  Neutralizá el olor o el gato vuelve a marcar
                </p>
              </div>
              <div className="flex flex-col items-end flex-shrink-0" data-id="element-255">
                <span className="text-xs text-[#1C1C1C]/40 line-through" data-id="element-256">
                  $9.500
                </span>
                <span className="text-base font-bold text-[#D97706]" data-id="element-257">
                  +$6.000
                </span>
              </div>
            </div>

            <AnimatePresence data-id="element-258">
              {orderBump1Checked && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-259">
                  <div className="px-3.5 md:px-4 pb-4 pt-1 border-t border-[#D97706]/15" data-id="element-260">
                    <div className="flex gap-3 items-start" data-id="element-261">
                      <img src="https://cdn.magicpatterns.com/uploads/f4Mk4cvL556mjqGQ7Cr1gb/ORDER_BUMP_01.png" alt="Scanner de Limpieza" className="w-20 h-20 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-262" />
                      <div className="space-y-1.5" data-id="element-263">
                        {['Guía de Marcas Argentina para romper la molécula del olor', 'Receta casera: neutralizador enzimático con 3 ingredientes', 'Protocolo para salvar colchones, sillones y madera'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-264">
                            <CheckCircle2Icon className="w-3 h-3 text-[#D97706] flex-shrink-0 mt-0.5" data-id="element-265" />
                            <span className="text-[11px] text-[#1C1C1C]/70 leading-snug" data-id="element-266">
                              {item}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* ORDER BUMP #2 - Control y Señales */}
          <div className={`mb-4 md:mb-6 rounded-xl border-2 transition-all overflow-hidden ${orderBump2Checked ? 'border-[#2D8C5A] bg-[#E8F0E8]' : 'border-dashed border-[#2D8C5A]/60 bg-white'}`} data-id="element-267">
            <div className="bg-[#2D8C5A] text-white text-[10px] font-bold uppercase tracking-wider text-center py-1.5 px-4 flex items-center justify-center gap-1.5" data-id="element-268">
              <StarIcon className="w-3 h-3 fill-white" data-id="element-269" />
              Altamente recomendado
            </div>
            <div onClick={() => setOrderBump2Checked(!orderBump2Checked)} className="flex items-center gap-3 p-3.5 md:p-4 cursor-pointer" data-id="element-270">
              <motion.div animate={{
              scale: orderBump2Checked ? 1 : 1,
              backgroundColor: orderBump2Checked ? '#1f6b42' : '#ffffff'
            }} className={`w-5 h-5 rounded flex-shrink-0 flex items-center justify-center border-2 transition-colors ${orderBump2Checked ? 'border-[#1f6b42]' : 'border-[#2D8C5A]'}`} data-id="element-271">
                {orderBump2Checked && <CheckCircle2Icon className="w-3.5 h-3.5 text-white" data-id="element-272" />}
              </motion.div>
              <div className="flex-1 min-w-0" data-id="element-273">
                <p className="text-sm font-semibold text-[#1C1C1C] leading-snug" data-id="element-274">
                  Calendario 72 Horas de Victoria
                </p>
                <p className="text-xs text-[#1C1C1C]/60" data-id="element-275">
                  Anticipá el accidente antes de que pase
                </p>
              </div>
              <div className="flex flex-col items-end flex-shrink-0" data-id="element-276">
                <span className="text-xs text-[#1C1C1C]/40 line-through" data-id="element-277">
                  $9.500
                </span>
                <span className="text-base font-bold text-[#2D8C5A]" data-id="element-278">
                  +$6.000
                </span>
              </div>
            </div>

            <AnimatePresence data-id="element-279">
              {orderBump2Checked && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-280">
                  <div className="px-3.5 md:px-4 pb-4 pt-1 border-t border-[#2D8C5A]/15" data-id="element-281">
                    <div className="flex gap-3 items-start" data-id="element-282">
                      <img src="https://cdn.magicpatterns.com/uploads/xjbYaLUMozNrPhxSXb4rRo/order_bump_02.png" alt="Calendario 72 Horas de Victoria" className="w-20 h-20 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-283" />
                      <div className="space-y-1.5" data-id="element-284">
                        {['Semáforo Felino: leé si tu gato está a punto de marcar', 'Hoja de Ruta Visual hora por hora (12, 24, 48, 72h)', 'Log de Diagnóstico para descubrir el disparador real'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-285">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-286" />
                            <span className="text-[11px] text-[#1C1C1C]/70 leading-snug" data-id="element-287">
                              {item}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* ── RESUMEN DINÁMICO ── */}
          <motion.div layout className="mb-6 rounded-xl bg-[#FAFAF7] border border-[#1C1C1C]/10 overflow-hidden" data-id="element-288">
            <div className="divide-y divide-[#1C1C1C]/5" data-id="element-289">
              <AnimatePresence data-id="element-290">
                {orderBump1Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-291">
                    <div className="px-5 py-3 flex items-center justify-between bg-[#FEF3C7]/50" data-id="element-292">
                      <span className="text-sm text-[#1C1C1C] flex items-center gap-2" data-id="element-293">
                        <AlertTriangleIcon className="w-4 h-4 text-[#D97706]" data-id="element-294" />
                        Scanner de Limpieza Técnica
                      </span>
                      <span className="text-sm font-semibold text-[#D97706]" data-id="element-295">
                        +{formatPrice(bump1Price)}
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>

              <AnimatePresence data-id="element-296">
                {orderBump2Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-297">
                    <div className="px-5 py-3 flex items-center justify-between bg-[#E8F0E8]/50" data-id="element-298">
                      <span className="text-sm text-[#1C1C1C] flex items-center gap-2" data-id="element-299">
                        <CheckCircleIcon className="w-4 h-4 text-[#2D8C5A]" data-id="element-300" />
                        Calendario 72 Horas de Victoria
                      </span>
                      <span className="text-sm font-semibold text-[#2D8C5A]" data-id="element-301">
                        +{formatPrice(bump2Price)}
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </motion.div>

          {/* ── VALUE STACK — Resumen de lo que te llevás hoy ── */}

          <div className="bg-[#E8F0E8] border border-[#2D8C5A]/20 rounded-xl p-4 md:p-6 mb-6 text-left" data-id="element-302">
            <h4 className="font-['Playfair_Display'] text-lg font-bold text-[#2D8C5A] mb-2 flex items-center gap-2" data-id="element-303">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-304" />
              Garantía de 7 días
            </h4>
            <p className="text-[#1C1C1C]/80 text-sm leading-relaxed" data-id="element-305">
              Si sentís que esta guía no te dio un plan claro para encarar el
              problema, te devolvemos el dinero. Sin preguntas.
            </p>
          </div>

          <motion.button onClick={handleCheckoutClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#2A5C42] text-white font-bold px-8 py-5 rounded-lg text-lg md:text-xl hover:bg-[#1f4531] transition-colors mb-4 text-center cursor-pointer shadow-lg" data-id="element-306">
            {'\xA1QUIERO RECUPERAR MI CASA AHORA!'}
          </motion.button>

          <div className="text-center mb-5 md:mb-8" data-id="element-307">
            <p className="text-[#8B4513] font-medium text-sm italic" data-id="element-308">
              "¿Todavía dudás? Pensá en la última vez que limpiaste a las 2 de
              la mañana. Este protocolo existe para que esa sea la última vez."
            </p>
          </div>

          <div className="text-xs text-[#1C1C1C]/60 font-medium" data-id="element-309">
            Compra 100% segura · Recibís el PDF en tu email al instante
          </div>
        </div>
      </motion.div>

      <UpsellPopup isOpen={showUpsellPopup} onClose={() => setShowUpsellPopup(false)} data-id="element-310" />
    </section>;
}